<template>
  <div >
    <div>
      <div class="search border-bottom">
        <router-link tag="div" to="/index/search/reset?search_type=2">
          <search-fake :placeholder="'搜索大咖、讲师'"></search-fake>
        </router-link>
      </div>
      <!-- <nav-tab >
        <template>
          <div>
            <router-link tag="div" to="dk" class="tab" replace >
              <span>大咖</span>
            </router-link>
          </div>
          <div>
            <router-link tag="div" to="js" class="tab" replace >
              <span>讲师</span>
            </router-link>
          </div>
        </template>
      </nav-tab> -->
    </div>
    <div class="list">
      <router-view></router-view>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Tab from '@/components/tab/tab'
import NavTab from '@/components/base/nav-tab/nav-tab'
import SearchFake from '@/components/base/search/search-fake'
export default {
  components: {
    SearchFake,
    NavTab,
    Tab
  },
  data() {
    return {
      active: 'all'
    }
  },
  created() {
  },
  methods: {
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .list{
    padding-bottom: size(100)
  }
  .search
    padding size(30)
</style>



// WEBPACK FOOTER //
// src/components/daka/daka.vue